import * as React from 'react';
import moment from 'moment';

import { DatePicker, DatePickerBaseProps } from './DatePicker';
import { OptionalDate } from './utility';

interface EndDatePickerProps extends DatePickerBaseProps {
  minDate: OptionalDate;
}

export const EndDatePicker: React.FC<EndDatePickerProps> = (props) => {
  const { onChange, initialValue, minDate } = props;
  return (
    <DatePicker
      initialValue={initialValue}
      onChange={onChange}
      minDate={minDate}
      maxDate={moment().startOf('day')}
      errorMessage="Invalid date; Date must be entered in mm/dd/yyyy format and be between the start date and now."
    />
  );
};
